

export default class Readmore {
    static init(){
        document.querySelectorAll('.readmore__link').forEach((item) => {
            const initialText = item.innerText
            const closeText = item.dataset.closeText
            const button = item

            button.addEventListener('click', (e) => {
                button.classList.toggle('opened')
                button.previousSibling.classList.toggle('opened')
                button.innerText = button.classList.contains('opened') ? closeText : initialText
            })
        })
    }
}